import React from 'react';

export default function CommunicationsDashboardShell({ children, panelOpen, panel, overlays = null }) {
  return (
    <div className="communications-dashboard page">
      <div className="main-layout">
        <div className="content-area">{children}</div>
        <aside
          className={`detail-panel${panelOpen ? ' open' : ''}`}
          aria-hidden={!panelOpen}
        >
          {panelOpen ? panel : null}
        </aside>
      </div>
      {overlays}
    </div>
  );
}
